<template>
  <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
    <h1 class="mb2">Calculate a rate&nbsp;card</h1>
    <lw-text-input
      v-validate="'required'"
      ref="rateName"
      :name="'name'"
      :label="'Rate card name'"
      :size="'large'"
      v-model="name"
      :error="errors.first('name')"
    />
    <lw-text-area
      :label="'Description'"
      :optional="true"
      :name="'description'"
      :size="'large'"
      v-model="description"
    />
    <div class="flex justify-content-space-between mb-margin">
      <button
        class="invisible-button negative-button"
        @click.prevent="cancel">Cancel</button>
      <button
        type="submit"
        name="submit"
        class="large-button accent-button mr1"
        @click.prevent="addRateCard">Next</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as firebase from 'firebase'
import TextInput from '../../livewires/TextInput'
import TextArea from '../../livewires/TextArea'

export default {
  components: {
    lwTextInput: TextInput,
    lwTextArea: TextArea
  },
  data () {
    return {
      name: '',
      description: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization'
    ])
  },
  mounted () {
    this.$refs.rateName.$el.children[0].focus()
  },
  methods: {
    addRateCard () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          const payload = {
            name: this.name,
            description: this.description,
            organization: this.organization.id,
            owner: this.user.id,
            created: updated,
            updated: updated,
            current: {
              incoming: 1,
              outgoing: 1,
              clients: 1,
              fullTimeEmployees: 1,
              billableEmployees: 1,
              averageSalary: 1,
              incomingPerEmployee: 1,
              outgoingPerEmployee: 1
            },
            goal: {
              incoming: 1,
              outgoing: 1,
              clients: 1,
              clientLoad: 1,
              fullTimeEmployees: 1,
              billableEmployees: 1,
              averageSalary: 1,
              billableHours: 1,
              workingWeeks: 52,
              incomingPerEmployee: 1,
              outgoingPerEmployee: 1
            },
            type: 'Calculated',
            archived: false
          }
          this.$store.dispatch('addRates', payload).then(response => {
            this.$router.push({ name: 'newRateEmployees', params: { id: response } })
          })
        }
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
